import * as defaultImageUrl from 'assets/img/default_template_image.png';
import * as defaultDocumentImageUrl from 'assets/img/default_template_document.png';
import * as defaultVideoImageUrl from 'assets/img/default_template_video.png';
import * as defaultInvalidImageUrl from 'assets/img/default_template_invalid_image.png';
import * as defaultInvalidVideoUrl from 'assets/img/default_template_invalid_video.png';
export const MessageTemplateDeafaultImageConstants = {
    MESSAGE_TEMPLATE_DEFAULT_IMAGE_URL: defaultImageUrl,
    MESSAGE_TEMPLATE_DEFAULT_DOCUMENT_IMAGE_URL: defaultDocumentImageUrl,
    MESSAGE_TEMPLATE_DEFAULT_VIDEO_IMAGE_URL: defaultVideoImageUrl,
    MESSAGE_TEMPLATE_IMAGE_INVALID_URL: defaultInvalidImageUrl,
    MESSAGE_TEMPLATE_VIDEO_INVALID_URL: defaultInvalidVideoUrl,
};
